import { NewFlexPass, SubscriptionType } from "../../types/FlexPassTypes";

export const parseNumberInRange = (
  value: string,
  min: number,
  max: number,
  requireInteger = false
) => {
  if (value.includes(".")) return true;

  const num = Number(value);
  if (
    isNaN(num) ||
    num < min ||
    num > max ||
    (requireInteger && !Number.isInteger(num))
  ) {
    return false;
  }

  return true;
};

export const isFlexPassValid = (data: NewFlexPass): boolean => {
  const baseFieldsFilled =
    data.title?.[0]?.text.trim() &&
    data.language &&
    data.mainSpecialization &&
    data.level &&
    data.startDate &&
    data.endDate &&
    typeof data.cost === "number" &&
    typeof data.duration === "number" &&
    data.type;

  if (!baseFieldsFilled) return false;

  if (data.type === SubscriptionType.DISCOUNT) {
    return (
      typeof data.sessionDiscount === "number" &&
      data.sessionDiscount >= 0 &&
      data.sessionDiscount <= 100 &&
      typeof data.talziCommissionPercent === "number" &&
      data.talziCommissionPercent >= 0 &&
      data.talziCommissionPercent <= 100
    );
  }

  if (data.type === SubscriptionType.SESSION_VOLUME) {
    return (
      typeof data.amountOfSessions === "number" &&
      data.amountOfSessions >= 0 &&
      typeof data.firstSessionPayout === "number" &&
      data.firstSessionPayout >= 0 &&
      typeof data.repeatSessionPayout === "number" &&
      data.repeatSessionPayout >= 0
    );
  }

  return false;
};

export const flexPassTypeStrings = {
  [SubscriptionType.DISCOUNT]: "Discount on sessions",
  [SubscriptionType.SESSION_VOLUME]: "Session volume",
};
